var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"spinner-wrap"},[_c('div',{staticClass:"spinner"},[_c('img',{attrs:{"src":require('@assets/images/loading.gif')}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }